import angular from 'angular';
import { eventsServiceFactory } from './eventsService.factory';
import { sampleEventFactory } from './sampleEvent.factory';

export const eventsServiceModule = angular
  .module('bit.services.eventsService', [])
  .factory('eventsService', eventsServiceFactory)
  .factory('sampleEvent', sampleEventFactory);
